import React, { useEffect, useState } from "react";
import styles from "./multiimagesChat.module.scss";
import ChatLike from "../chatLike";
import { Tooltip } from "antd";
import ChatHoverOption from "../chatHoverOption";
//*import ChatAttachmentsOption from "../chatAttachmentOption";
import moment from "moment";
import ChatUserInfo from "../chatUserInfo";
import ChatLeftInfo from "../chatLeftInfo";
import ChatRightInfo from "../chatRightInfo";
//*import { chatReducer } from "../../../../context/reducer/chatReducer";
import { useSelector } from "react-redux";
import { chats, initialStateModel } from "../../../../models/model";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { URCheckBoxCall } from "../../../../shared/widgets/checkBoxForCall/callCheckBox";
//*import { ChatService } from "../../../../base/chatService";
import FilePreview from "../filePreview";
import _ from "lodash";
import ImagePreview from "./imagePreview";
import ForwardHeader from "../forwardHeader";
import { getTeamMembersnamelist, urlify, urlifyATmention } from "../../../../base/utils";

// import ChatHoverOption from "../chatHoverOption";
type multiimagesChatProps = {
  data: any;
  previewopen?: Function;
  multiData?: any;
  audioVideo?: any;
  savedData?: any;
  timeValue?: any;
};
type fileMessageState = {
  isOpen: boolean;
  id: any;
  dataRes: any;
};
const MultiChatImageMessage = React.memo(
  ({ data, multiData, audioVideo, savedData, timeValue }: multiimagesChatProps) => {
    const [fileState, setfileState] = useState<fileMessageState>({ isOpen: false, id: "", dataRes: "" });
    let { id, direction, timestamp, fromcaller_details } = Array.isArray(data) && data?.length > 0 ? data[0] : "";
    const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
    const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
    const { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
    let htimestamp = moment(timestamp).format("hh:mm A");
    let { messageList }: any = chatSocketMessage;
    let timeCount = timeValue !== undefined ? timeValue : 18;
    let likeFiltered = _.filter(data, function(ele:any) {
      return  ele.message.liked;
    });
    //let fileRes = data?.contacts;
    //let messageBody = data?.length >0 && !data[0].message.isDeleted?_.isObject(data[0].message.body) ? data[0].message.body: JSON.parse(data[0].message.body):"";
    let messageBody = Array.isArray(data) && data?.length > 0 ? data[0].message.body : "";
    let isReply = Array.isArray(data) && data?.length > 0 && data[0].message?.isReply ? true : false;
    const [longText, setlongtext] = useState(0);
    let mstext = messageBody?.text;
    if(mstext && mstext !== ""){
      if (mstext.length > 760 && longText === 0) {
        mstext = mstext.substring(0, 760) + "...";
      }
    }
 
     if(messageBody?.mentionID !== '' && messageBody?.mentionID !== undefined ){
      let test = urlifyATmention(messageBody ,mstext)
      mstext = test;
     }
   
    useEffect(() => {
      var focusableInputElements: any = document.querySelectorAll(".focusText");
      if (focusableInputElements.length > 0 && chatReducer.isSaveChat) {
        focusableInputElements[0].focus();
      }
      
    }, [savedData]);
    
    const FilePreviewer = () => {
      setfileState({ ...fileState, isOpen: !fileState.isOpen });
    };

    const handleCheckBoxClick = () => {
      if (chatReducer?.isDelete || chatReducer?.isForward) {
        //ChatService.selectedMessageDispatch(data[0]);
      }
    };

    const handlehighlightHover = () => {
      var element: HTMLElement | any = document.getElementById(id) || null;
      if (element != null) {
        element.classList.add("highlighthover");
      }
    };

    const handleOnChange = (e: any) => {
      let deletedArray: any = chatReducer.selectMessageData;

      let index = [];
      if (e.target.checked) {
        let arr: any = [...deletedArray, ...multiData];
        store.dispatch({
          type: Types.SELECT_MESSAGE_ARRAY,
          payload: {
            selectMessageData: arr
          }
        });
      } else {
        _.forEach(multiData, function (element: any) {
          index = deletedArray.indexOf(element);
          deletedArray.splice(index, 1);
        });

        store.dispatch({
          type: Types.SELECT_MESSAGE_ARRAY,
          payload: {
            selectMessageData: deletedArray
          }
        });
      }
    };
   
    const readMoreChange = ()=>{
      setlongtext(1);
    }
    let isBookmark:any = data[0]?.message?.isSave;
    let widthMulti = (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 ) && data[0]?.message?.isEdit ?"saveEdited": 
    (!data[0]?.message?.isDelete && (!isBookmark || isBookmark["s" + userdetails?.sip_login_id]) === 1 )?"onlySaved": data[0]?.message?.isEdit ? "onlyEdited" : "widthDefault";
   
    
    return (
      <>
        {fileState.isOpen && (
          <FilePreview
            isOpen={fileState.isOpen}
            data={fileState.dataRes}
            previewopen={FilePreviewer}
            groupdata={messageList}
          />
        )}
        {direction === "IN" ? (
          <div
            className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} lftMessage ${styles.chatMsg} ${styles.leftMessage
              } ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`} id={id}>
             {!isReply && timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
              <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon leftSide" />
              <div className={styles.convMemName}>
                <span>{fromcaller_details?.caller_id}</span>
              </div>
            </div>}
            
            <div className={styles.chatLeftMessages}>
              <div className={styles.chatLeft}>
                {!isReply && (
                  <Tooltip title={htimestamp} className="cusTooltip" overlayClassName="customTooltip">
                    <div className={styles.chatTime}>{htimestamp}</div>
                  </Tooltip>
                )}
                <div className={`${styles.chatContent}`}>
                <div className={`msgContentLft ${styles.imageChat} ${data.length>3 ? styles.imageGrouped: ""}`}>
                  {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                 
                     
                    <div className={styles.imageList}>
                      {data.map((msgList: any, index: any) => {
                        // console.log(msgList,'Inside File IN Direction',msgList?.direction);
                        if (msgList?.direction === "IN" && index <= 3) {
                          return (
                            <React.Fragment key={index}>
                              <span className={id === savedData ? "focusText" : ""} tabIndex={0}>
                                <ImagePreview data={msgList} multiData={data} index={index}></ImagePreview>
                              </span>
                            </React.Fragment>
                          );
                        } else {
                          return null;
                        }
                      })}
                      
                    </div>
                    {messageBody?.text && messageBody?.text !== "" &&
                      <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>
                      <span className={widthMulti}></span>
                    </div>
                    }

                    {!isReply && audioVideo === 0 && messageBody?.text && 
                    <ChatLeftInfo
                      userDetails={fromcaller_details}
                      timeStamp={timestamp}
                      message={Array.isArray(data) && data.length > 0 ? data[0] : []}
                    ></ChatLeftInfo>}
                    <div className="highlightOverlay"></div>
                  </div>

                  { Array.isArray(data) && data?.length > 0 && (
                    <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                      <ChatHoverOption
                        className="hoverList hoverListleft"
                        data={Array.isArray(data) && data?.length > 0 && data[0]}
                        multiFile={multiData}
                        highlightHover={handlehighlightHover}
                      />

                    </div>
                  )}
                </div>
              </div>
              {Array.isArray(data) && data?.length > 0 && !isReply && (
                <ChatLike
                  className="likeLeft"
                  placement="topRight"
                  tooltipTitle={data[0]?.likeduserdetails}
                  message={Array.isArray(likeFiltered) && likeFiltered?.length >0 ? likeFiltered[0]: data[0]} multiData={likeFiltered}
                />
           
              )}
            </div>
            
            {(!isReply && (!chatReducer?.isDelete && chatReducer?.multiOption) ) && Array.isArray(data) && data?.length > 0 && (
              <URCheckBoxCall
                checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
                className="chatSelectRight"
                onChange={handleOnChange}
              />
            )}
          </div>
        ) : (
          <div
            className={`${chatReducer.isSaveChat && id === savedData ? "savedhighlight" : ""} rtMessage ${styles.chatMsg} ${styles.rightMessage
              } 
              ${(chatReducer?.multiOption && chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ) ? "checked" : chatReducer?.multiOption?"checking":""}`}
            onClick={handleCheckBoxClick}
            id={id}
          >
           {!isReply && audioVideo === 0 && timeCount > 15 && <div className={`${styles.chatUserDetails}`}>
              <div className={styles.convMemName}>
                <span>You</span>
              </div>
              <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon rightSide" />
            </div> }
            <div className={styles.chatRightMessages}>
              <div className={styles.chatRight}>
                <div className={`${styles.chatContent}`}>
              
                  <div className={`msgContentRT ${styles.imageChat} ${data.length>3 ? styles.imageGrouped: ""}`}>
                    
                  {Array.isArray(data) && data[0]?.message?.forward && <ForwardHeader />} 
                    <div className={styles.imageList}>
                      {data.map((msgList: any, index: any) => {
                        // console.log(msgList,'Inside File OUT Direction',msgList?.direction);
                        if (msgList?.direction === "OUT" && index <= 3) {
                          return (
                            <>
                              <span key={index} className={id === savedData ? "focusText" : ""} tabIndex={0}>
                             <ImagePreview index={index} data={msgList} multiData={data}></ImagePreview>
                              </span>
                            </>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                    {messageBody?.text && messageBody?.text !== "" &&
                      <div className="textContent">
                      <span className={`textmsg ${styles.messageContent}`} >
                     <span  dangerouslySetInnerHTML={{ __html: urlify(mstext) }}></span>
                      {mstext.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                    </span>
                      <span className={widthMulti}></span>
                    </div>
                    }
                    
                    {!isReply && audioVideo === 0 && messageBody?.text && (
                      <ChatRightInfo
                        userDetails={fromcaller_details}
                        timeStamp={timestamp}
                        message={Array.isArray(data) && data.length > 0 ? data[0] : []}
                      ></ChatRightInfo>
                    )}
                    <div className="highlightOverlay"></div>
                  </div>
                  {/* {data?.length > 1 && audioVideo === 0 && (
                    <div className={styles.fileCount}>
                      <span>{data?.length} Files</span>
                    </div>
                  )} */}

                  {/* <div className={styles.fileCount}><span>10 Files</span></div> */}
                  {/* <StatusTag className='statusTag atMentionTag' name='@ Miguel Logan'/>
              <ChatLike className='likeRight' tooltipTitle='Kyle Hill,Aaron Ross, Denise Gordon, 
              Beverly Powell, Philip Fuller'/> */}
                  {audioVideo === 0 && Array.isArray(data) && data?.length > 0 && (
                    <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                      <ChatHoverOption
                        className="hoverList hoverListright"
                        data={Array.isArray(data) && data?.length > 0 && data[0]}
                        multiFile={multiData}
                        highlightHover={handlehighlightHover}
                      />
                    </div>
                  )}

                </div>
              </div>
              {Array.isArray(data) && data?.length > 0 && !isReply && (
              <ChatLike
                className="likeRight"
                placement="topRight"
                tooltipTitle={data[0]?.likeduserdetails}
                message={Array.isArray(likeFiltered) && likeFiltered?.length >0 ? likeFiltered[0]: data[0]} multiData={likeFiltered}
              />
            )}
            </div>
            {(!chatReducer?.isDelete && chatReducer?.multiOption) && Array.isArray(data) && data?.length > 0 && (
              <URCheckBoxCall
                checked={chatReducer?.selectMessageData?.indexOf(data[0]) > -1 ? true : false}
                className="chatSelectRight"
                onChange={handleOnChange}
              />
            )}
          </div>
        )}
      </>
    );
  }
);

export default MultiChatImageMessage;
